import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixel } from '../lib/pixel.js';

// Fires PageView on every client-side route change (the base snippet in
// index.html only initialises the pixel).
export default function PixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    trackPixel('PageView');
  }, [pathname]);

  return null;
}
